<section class="main-section">
  <div class="d-flex justify-content-between">
    <div>
      <nav aria-label="breadcrumb">
        <nav class="breadcrumb p-3" aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a routerLink="/admin/dashboard/">Home</a></li>
            <li class="breadcrumb-item"><a routerLink="/admin/credits/">Credits</a></li>
            <li class="breadcrumb-item active" aria-current="page">Credits Processing</li>
          </ol>
        </nav>
      </nav>
    </div>
  </div>


  <div class="row mt-2">
    <div class="inner-box ">
        <div class="row d-flex justify-content-around my-3">
          <div class="col-md-6">
            <div class="row d-flex justify-content-around">
          <div class="col form-group">
            <label class="control-label">Amount</label>
            <input type="text" id="amount" class="form-control" (blur)="typeAmount()"
                   [ngClass]="{'is-invalid':amountError}" [(ngModel)]="amount"
                   [ngModelOptions]="{standalone: true}" appOnlyNumbers required>
            <div id="amountError" class="invalid-feedback d-block shift-invalid-login" [hidden]="!amountError">
              {{amountError}}
            </div>
          </div>
          <div class="col-md-6 ms-1">
            <button id="Button" class="btn btn-orange" (click)="pay()" style="margin-top: 23px;">Pay Now</button>
          </div>
            </div>
          </div>
          <div class=" col-md-6 " style="text-align: right">
            <img referrerpolicy="origin"
                 src="https://badges.razorpay.com/badge-dark.png "
                 style="height: 67px;width: 165px;"
                 alt="Razorpay | Payment Gateway | Neobank">
          </div>
        </div>
    </div>
  </div>
</section>
